// extracted by mini-css-extract-plugin
export default {"MainConatiner":"Head_MainConatiner__t0SSQ","backButton":"Head_backButton__RQAqY","UserPicture":"Head_UserPicture__--YoU"};